import React from "react";

const ItemsInputFieldStandalone = ({
  label = "Label",
  isLabelReq = true,
  placeholder = "Enter text",
  labelClass = "",
  value,
  onChange,
  leftIcon = null,
}) => {
  return (
    <div className="flex items-center gap-3 w-full">
      {isLabelReq && (
        <label
          className={`text-[var(--stand-alone-input-label-color)] text-[length:var(--stand-alone-label-fs)] font-[var(--stand-alone-label-font-weight)] ${labelClass} text-nowrap`}
        >
          {label}
        </label>
      )}

      <div className="relative w-full">
        {leftIcon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--stand-alone-place-color)]">
            {leftIcon}
          </div>
        )}
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={`
                h-[44px] w-full rounded-[8px] px-3
                ${leftIcon ? "pl-8" : ""} 
                outline-none border
                text-[var(--stand-alone-input-color)]
                text-[length:var(--stand-alone-input-font-size)]
                font-[var(--stand-alone-input-font-weight)]
                bg-[var(--stand-alone-input-bg)]
                border-[var(--stand-alone-input-border)]
                focus:border-[var(--stand-alone-input-focus)]
                placeholder:text-[var(--stand-alone-place-color)]
                placeholder:text-[length:var(--stand-alone-place-font-size)]
                placeholder:font-[var(--stand-alone-place-font-weight)]
              `}
        />
      </div>
    </div>
  );
};

export default ItemsInputFieldStandalone;
